/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { TuteurSelectorGridDto } from './TuteurSelectorGridDto';
import {
    TuteurSelectorGridDtoFromJSON,
    TuteurSelectorGridDtoFromJSONTyped,
    TuteurSelectorGridDtoToJSON,
} from './TuteurSelectorGridDto';

/**
 * 
 * @export
 * @interface TuteurSelectorGridDtoPaginatedResults
 */
export interface TuteurSelectorGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof TuteurSelectorGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<TuteurSelectorGridDto>}
     * @memberof TuteurSelectorGridDtoPaginatedResults
     */
    results?: Array<TuteurSelectorGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof TuteurSelectorGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the TuteurSelectorGridDtoPaginatedResults interface.
 */
export function instanceOfTuteurSelectorGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TuteurSelectorGridDtoPaginatedResultsFromJSON(json: any): TuteurSelectorGridDtoPaginatedResults {
    return TuteurSelectorGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function TuteurSelectorGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuteurSelectorGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(TuteurSelectorGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function TuteurSelectorGridDtoPaginatedResultsToJSON(value?: TuteurSelectorGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(TuteurSelectorGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

